import React from 'react';
import { useDraggable } from '@dnd-kit/core';

type Props = { itemKey: string; label: string; icon: any };

export default function DraggableEntity({ itemKey, label, icon }: Props) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: itemKey,
  });
  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;
  return (
    <div className="entity-item">
      <span className="label">{label}</span>
      <span className="item">
        <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
          {icon}
        </div>
      </span>
    </div>
  );
}
